import request from '@/utils/request'

// 优惠券管理 分页 前台
export function pageByDTO(query) {
    return request({
        url: '/coupon/pageByDTO',
        method: 'get',
        params: query
    })
}

// 优惠券管理 集合 前台
export function listByDTO(query) {
    return request({
        url: '/coupon/listByDTO',
        method: 'get',
        params: query
    })
}

// 查询可用优惠券 前台
export function getAttendCoupon(query) {
    return request({
        url: '/coupon/getAttendCoupon',
        method: 'get',
        params: query
    })
}
